exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".formCard[data-v-36ac6668]{border:none!important;padding:0}.modal fade show d-block[data-v-36ac6668]{background:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-36ac6668","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/dashboard/profitlossDashboardNew.vue
// module id = 1502
// module chunks = 0